const STATUS_ABNORMAL = 0;
const STATUS_NOT_STARTED = 1;
const STATUS_IN_PROGRESS = 3;
const STATUS_FIRST_SET = 51;
const STATUS_SECOND_SET = 52;
const STATUS_THIRD_SET = 53;
const STATUS_FOURTH_SET = 54;
const STATUS_FIFTH_SET = 55;
const STATUS_END = 100;
const STATUS_WALKOVER = 20;
const STATUS_RETIRED = 21;
const STATUS_WALKOVER1 = 22;
const STATUS_WALKOVER2 = 23;
const STATUS_RETIRED1 = 24;
const STATUS_RETIRED2 = 25;
const STATUS_DEFAULTED1 = 26;
const STATUS_DEFAULTED2 = 27;
const STATUS_POSTPONED = 14;
const STATUS_DELAYED = 15;
const STATUS_CANCELED = 16;
const STATUS_INTERRUPTED = 17;
const STATUS_SUSPENSION = 18;
const STATUS_CUT_IN_HALF = 19;
const STATUS_TO_BE_DETERMINED = 20;

const STATUS_MATCH_NOT_STARTED = 1;
const STATUS_MATCH_EMPTY = 2;
const STATUS_MATCH_SEEDED = 3;
const STATUS_MATCH_PARTIAL_SEEDED = 4;
const STATUS_MATCH_SEEDED_FIXTURE = 5;
const STATUS_MATCH_ON_GOING = 6;
const STATUS_MATCH_HOME_WON = 7;
const STATUS_MATCH_AWAY_WON = 8;
const STATUS_MATCH_CANCELLED = 9;
const STATUS_MATCH_BYE = 10;
const STATUS_MATCH_WAITING_FOR_THE_DRAW = 11;

export = {
  STATUS_ABNORMAL,
  STATUS_NOT_STARTED,
  STATUS_IN_PROGRESS,
  STATUS_FIRST_SET,
  STATUS_SECOND_SET,
  STATUS_THIRD_SET,
  STATUS_FOURTH_SET,
  STATUS_FIFTH_SET,
  STATUS_END,
  STATUS_WALKOVER,
  STATUS_RETIRED,
  STATUS_WALKOVER1,
  STATUS_WALKOVER2,
  STATUS_RETIRED1,
  STATUS_RETIRED2,
  STATUS_DEFAULTED1,
  STATUS_DEFAULTED2,
  STATUS_POSTPONED,
  STATUS_DELAYED,
  STATUS_CANCELED,
  STATUS_INTERRUPTED,
  STATUS_SUSPENSION,
  STATUS_CUT_IN_HALF,
  STATUS_TO_BE_DETERMINED,

  STATUS_MATCH_NOT_STARTED,
  STATUS_MATCH_EMPTY,
  STATUS_MATCH_SEEDED,
  STATUS_MATCH_PARTIAL_SEEDED,
  STATUS_MATCH_SEEDED_FIXTURE,
  STATUS_MATCH_ON_GOING,
  STATUS_MATCH_HOME_WON,
  STATUS_MATCH_AWAY_WON,
  STATUS_MATCH_CANCELLED,
  STATUS_MATCH_BYE,
  STATUS_MATCH_WAITING_FOR_THE_DRAW,

  LIST_STATUS_PLAYING: [
    STATUS_FIRST_SET,
    STATUS_SECOND_SET,
    STATUS_THIRD_SET,
    STATUS_FOURTH_SET,
    STATUS_FIFTH_SET,
  ],

  MATCH_STATUS_TEXT: {
    0: "Bất thường (Đề nghị ẩn)",
    1: "Chưa bắt đầu",
    3: "Đang diễn ra",
    51: "SET 1",
    52: "SET 2",
    53: "SET 3",
    54: "SET 4",
    55: "SET 5",
    100: "Kết thúc",
    20: "Thắng ván",
    21: "Rút lui",
    22: "Thắng ván 1",
    23: "Thắng ván 2",
    24: "Rút lui 1",
    25: "Rút lui 2",
    26: "Mất quyền thi đấu 1",
    27: "Mất quyền thi đấu 2",
    14: "Hoãn lại",
    15: "Bị trễ",
    16: "Đã hủy",
    17: "Gián đoạn",
    18: "Tạm dừng",
    19: "Cắt đôi",
    99: "Chưa xác định",
  },
  MATCH_STATUS_ACTIVE: [
    STATUS_IN_PROGRESS,
    STATUS_FIRST_SET,
    STATUS_SECOND_SET,
    STATUS_THIRD_SET,
    STATUS_FOURTH_SET,
    STATUS_FIFTH_SET,
  ],

  GROUND_TYPE_STTAUS: {
    0: "Sân cứng",
    1: "Sân cứng",
    2: "Sân cỏ",
    3: "Sân đất nện",
    4: "Sân đất nện",
    5: "Sân cứng ngoài trời",
    6: "Thảm trong nhà",
    7: "Tổng hợp trong nhà",
    8: "Tổng hợp ngoài trời",
    9: "Sân cứng trong nhà",
    10: "Sân đất nện",
  },
};
